module.exports = __webpack_public_path__ + "img/share.0afe14f9.svg";